import emitter from 'tiny-emitter/instance';

const newLoadingAttemptInterval = 1000;
const maxScriptLoadingAttemptCount = 5;
const cantLoadStripeError = 'There is no ability to load a third party tool for payment. Try to reload page.';
export default {
  data: () => ({
    scriptsLoadingAttemptNumbers: {},
    /** key = script url. val - boolean. True if script is loaded. */
    scriptsLoadingStates: {},
  }),
  methods: {
    tryToLoadScript(scriptUrl, errorText = cantLoadStripeError) {
      return new Promise((resolve, reject) => {
        this.tryNewLoadingAttempt(resolve, reject, scriptUrl, errorText);
      });
    },
    tryNewLoadingAttempt(resolve, reject, scriptUrl, errorText) {
      this.incrementLoadingsCounter(scriptUrl);
      if (this.scriptsLoadingAttemptNumbers[scriptUrl] > maxScriptLoadingAttemptCount) {
        emitter.emit('error', errorText);
        reject(errorText);
        return;
      }
      this.loadScript(resolve, reject, scriptUrl, errorText);
    },
    incrementLoadingsCounter(scriptUrl) {
      if (!this.scriptsLoadingAttemptNumbers[scriptUrl]) {
        this.scriptsLoadingAttemptNumbers[scriptUrl] = 0;
      }
      this.scriptsLoadingAttemptNumbers[scriptUrl] += 1;
    },
    loadScript(resolve, reject, scriptUrl, errorText) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = scriptUrl;
      script.onload = resolve;
      script.onreadystatechange = resolve;
      script.onerror = () => {
        setTimeout(() => {
          this.tryNewLoadingAttempt(resolve, reject, scriptUrl, errorText);
        }, newLoadingAttemptInterval);
      };
      document.head.appendChild(script);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/loadingScripts.js